import React from "react";
import "./page.css";

const Team = () => {
    const title = (
        <>
            Team
        </>  
    );

    const team = {
        "Faculty member": [
            { name: "Valérie Viet Triem Tong", email: "valerie.viettriemtong@centralesupelec.fr" },
        ],
        "Engineer": [
            { name: "Alexandre Sanchez", email: "alexandre.sanchez@inria.fr" },
            { name: "Frédéric Beck", email: "frederic.beck@inria.fr" },
        ],
        "PhD students": [
            { name: "Pierre-Victor Besson" },
            { name: "Hélène Orsini" },
            { name: "Yohann Morel"},
            { name: "Natan Talon"},
            { name: "Matthieu Mouzaoui"},
        ],
        "Interns": [
            { name: "Yohann Morel (2024)"},
            { name: "Gayathiri Ravendirane (2024)" },
            { name: "Guillaume Vachez (2024)" },
            { name: "Marius Le Douarin (2023)" },
        ]
    };

    return (
        <div className="page">
            <div className="page-title">
                <h1>{title}</h1>
            </div>
            <br />
            <br />
            <br />

            {Object.keys(team).map((category, index) => (
                <div key={index}>
                    <div className="page-category">
                        <h2>{category}</h2>
                        <ul className="page-list">
                            {team[category].map((team, subIndex) => (
                                <li key={subIndex} className="page-item">
                                    <h3>
                                        {team.email ? (
                                            <a 
                                                className="page-link"
                                                href={`mailto:${team.email}`} 
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {team.name}
                                            </a>
                                        ) : (
                                            team.name
                                        )}
                                    </h3>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <br />
                </div>
            ))}
        </div>
                
    );
};

export default Team;
